import { render, staticRenderFns } from "./FeaturedQuotes.vue?vue&type=template&id=274aea94&scoped=true&"
import script from "./FeaturedQuotes.vue?vue&type=script&lang=js&"
export * from "./FeaturedQuotes.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedQuotes.vue?vue&type=style&index=0&id=274aea94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274aea94",
  null
  
)

export default component.exports